import { useQuery, useQueryClient } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const fetchAllPaginatedFiles = async ({
  page = 0,
  limit = 25,
  type = [],
  sort_order = 'desc',
  search = '',
} = {}) => {
  const params = new URLSearchParams()

  if (page) params.append('page', page)
  if (limit) params.append('limit', limit)
  if (type && type.length > 0) {
    params.append('type', type.join(','))
  }
  if (sort_order) params.append('sort_order', sort_order)
  if (search) params.append('search', search)

  const url = `${API_BASE_URL}/paginated-file/list?${params.toString()}`
  const { data } = await axios.get(url)

  return data
}

export const usePaginatedFiles = ({ page = 0, limit = 25, type = [], sort_order = 'desc', search = '' } = {}) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['all-files', page, limit, type, sort_order, search],
    () => fetchAllPaginatedFiles({ page, limit, type, sort_order, search }),
    {
      refetchInterval: 1000 * 15, // 15 seconds
      refetchIntervalInBackground: 1000 * 60, // 1 minute
      refetchOnWindowFocus: true,
      keepPreviousData: true,
    },
  )
  const refresh = async () => {
    console.log('REFRESHING')
    await queryClient.refetchQueries('all-files')
    await queryClient.resetQueries('all-files')
  }

  return { query, refresh }
}

export const fetchAllFiles = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/file/list`)

  return data
}
export const useFiles = () => {
  const queryClient = useQueryClient()

  const query = useQuery(['all-files'], fetchAllFiles, {
    refetchInterval: 1000 * 15, // 15 seconds
    refetchIntervalInBackground: 1000 * 60, // 1 minute
    refetchOnWindowFocus: true,
  })
  const refresh = async () => {
    console.log('REFRESHING')
    await queryClient.refetchQueries('all-files')
    await queryClient.resetQueries('all-files')
  }

  return { query, refresh }
}

const fetchBedFiles = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/bed/list`)
  return data
}

export const useFileDetails = (fileId) => {
  const queryClient = useQueryClient()
  const query = useQuery(
    ['file-details', fileId],
    async () => {
      const { data } = await axios.get(`${API_BASE_URL}/file/${fileId}`)
      return data
    },
    { enabled: !!fileId },
  )
  const refresh = async () => {
    await queryClient.refetchQueries('file-details')
    await queryClient.resetQueries('file-details')
  }

  return { query, refresh }
}

export const useBedFiles = () => {
  const queryClient = useQueryClient()
  const query = useQuery(['bed-files'], fetchBedFiles, {
    refetchOnWindowFocus: true,
  })
  const refresh = async () => {
    await queryClient.refetchQueries('bed-files')
    await queryClient.resetQueries('bed-files')
  }

  // TODO:  REMOVE THIS AFTER ILLUMINA IS FIXED
  if (query.data && Array.isArray(query.data)) {
    query.data = query.data.filter((bedFile) => bedFile.name !== 'IlluminaExome2.5Panel.bed')
  }

  return { query, refresh }
}

export const updateFinishInfo = async (fileId) => {
  const { data } = await axios.put(`${API_BASE_URL}/file/${fileId}`, {
    type: 'finish',
  })
  return data
}

export const updateFileNotes = async (fileId, notes) => {
  const { data } = await axios.put(`${API_BASE_URL}/file/${fileId}`, {
    type: 'notes',
    notes,
  })
  return data
}

export const returnFileType = async (fileId) => {
  const { data } = await axios.get(`${API_BASE_URL}/file/${fileId}/type`)
  return data
}
